// extracted by mini-css-extract-plugin
var _1 = "MobileGroup_groupWrapper__4281f";
var _2 = "MobileGroup_scaledAnswerContainer__a6132";
export { _1 as "groupWrapper", _2 as "scaledAnswerContainer" }
